export default function toast(msg, variant) {
    const stack = document.getElementById("toasts") || this.element.querySelector("#toasts");
    if (!stack) return console.warn(msg);
    const el = document.createElement("div");
    el.className = "text-sm rounded-md px-3 py-2 shadow";
    el.style.backgroundColor = variant === "success" ? "#16a34a" : variant === "info" ? "#3b82f6" : "#dc2626";
    el.style.color = "white";
    el.textContent = msg;
    stack.appendChild(el);
    setTimeout(() => el.remove(), 4000);
}